module.exports = __webpack_public_path__ + "static/media/LaraCroft.0dcb019b.png";